import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/features/auth/auth-context";
import { m } from "@/i18n/en";
import { Skeleton } from "@/components/ui/skeleton";

export function ProtectedRoute() {
  const { state } = useAuth();
  const location = useLocation();
  if (state === "loading")
    return (
      <main
        aria-busy="true"
        aria-label={m.loading}
        className="mx-auto grid min-h-screen max-w-5xl content-center gap-4 px-6"
      >
        <Skeleton className="h-12 w-64" />
        <Skeleton className="h-72 w-full" />
      </main>
    );
  if (state === "anonymous")
    return (
      <Navigate replace state={{ from: location.pathname }} to="/sign-in" />
    );
  return <Outlet />;
}
